import React from 'react';

const BrandLogo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  return (
    <div className={`relative flex items-center justify-center ${sizes[size]} ${className}`}>
      {/* Outer Hexagon Shield */}
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full drop-shadow-[0_0_8px_rgba(139,92,246,0.5)]">
        <path 
          d="M50 5 L90 25 L90 75 L50 95 L10 75 L10 25 Z" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="6"
          strokeLinejoin="round"
          className="text-violet-500"
        />
      </svg>
      {/* Inner Signal Pulse */}
      <svg viewBox="0 0 100 100" className="relative z-10 w-3/5 h-3/5">
        <circle cx="50" cy="50" r="8" className="fill-emerald-400" />
        <path 
          d="M30 50 Q40 30 50 50 T70 50" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="8" 
          strokeLinecap="round"
          className="text-violet-400 origin-center animate-pulse"
        />
        <path 
          d="M20 50 Q35 15 50 50 T80 50" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="6" 
          strokeLinecap="round" 
          opacity="0.4"
          className="text-emerald-400"
        />
      </svg>
    </div>
  );
};

export default BrandLogo;